import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { MatChipInputEvent, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption, MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-multi-traveler-managment',
    templateUrl: './multi-traveler-managment.component.html',
    styleUrls: ['./multi-traveler-managment.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatError, MatSuffix, MatSelect, NgFor, MatOption, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput, MatAutocompleteTrigger, MatAutocomplete, MatCheckbox, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions, AsyncPipe]
})
export class MultiTravelerManagmentComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['Traveler Count', 'Applied On', 'Product', 'Action']
  sauserId!: string;
  multiTravelerForm!: FormGroup;
  Addnew: boolean = false;
  selectedRule!: number;
  query!: number;
  AssociatedWithBranchArray: any[] = [];
  branchIdArray: any[] = []; // Ensure it's an array
  departmentArray: any[] = [];
  assoBrnchIdArray: any[] = [];
  isEditing = false;
  editedItem: any;
  isLoading = true; // Start loading state

  commonObjPipes: any = {
    GetAllMultiTravelerDetails: { pipe: [], all: [] },
    GetRuleAppliesOn: { pipe: [], all: [] },
    GetDesignationData: { pipe: [], all: [] },
    GetdepartmentData: { pipe: [], all: [] },
    AssociatedWithBranch: { pipe: [], all: [] },
    AssociateedWithBranchIni: { pipe: [], all: [] },
    GetProdectData: { pipe: [], all: [] },
    GetBranchData: { pipe: [], all: [] },
    GetGradeData: { pipe: [], all: [] },
  }
  EditArrayLists: any = {};
  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;

  dropdowns: any = {
    2: "GetBranchData", // Branches
    3: "GetdepartmentData", // Departments
    4: "GetDesignationData", // Designations
    5: "GetGradeData", // Grades
  };

  //chips dropdown for associated for rule applied on
  separatorKeysCodes: number[] = [ENTER, COMMA];
  ruleAppliedFor = new FormControl('');
  filteredAssocatedWithRule: Observable<any[]>;
  associatedRuleName: string[] = [];
  selectedAssoicatedRuleIdMap: { [key: number]: boolean } = {};
  @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;
  announcer = inject(LiveAnnouncer);

  //chips dropdown for associated with department,designation and employee grade
  associatedWithBranchId = new FormControl('');
  filteredDeptDesGrade: Observable<any[]>;
  deptDesGradeName: string[] = [];
  selectedAssoicatedDeptDesGradeIdMap: { [key: number]: boolean } = {};
  private destroy$ = new Subject<void>();
  content:any;

  constructor(private crypto: CryptoService, private _camService: CamService, private fb: FormBuilder, private dialog: MatDialog, private _ToastrApiService: ToastrApiService, private _CommonService: CommonService, private _CompanyManagementService: CompanyManagementService,private contentService:CompanyManagementContentService) {

    this.multiTravelerForm = this.fb.group({
      multiTravelerRuleId: [0],
      numbarOfTraveler: ['', [Validators.required, Validators.maxLength(8)]],
      product: ['', [Validators.required]],
      ruleAppliedOn: ['', [Validators.required]],
      ruleAppliedFor: ['', [Validators.required]],
      sauserid: [this.crypto.getValueFromKey('USERID') as string],
      queryNo: [1],
      associatedWithBranchId: ['', [Validators.required]]
    })

    //  this.filteredFruits = this.ruleAppliedFor.valueChanges.pipe(
    //     startWith(null),
    //     map((fruit: string | null) => (fruit ? this._filter(fruit) : this.allFruits.slice())),
    //   );

    this.filteredAssocatedWithRule = this.ruleAppliedFor.valueChanges.pipe(
      startWith(null),
      map((value: string | null) => {
        if (typeof value === 'string') {
          return this._filter(value);
        } else {
          return this.commonObjPipes[this.dropdowns[this.multiTravelerForm.value.ruleAppliedOn]]?.pipe.slice();
        }
      })
    );

    this.filteredDeptDesGrade = this.associatedWithBranchId.valueChanges.pipe(
      startWith(null),
      map((value: string | null) => {
        if (typeof value === 'string') {
          return this._filterDeptDesGrade(value);
        } else {
          return this.AssociatedWithBranchArray.slice();
        }
      })
    );

  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    })
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.sauserId = this.crypto.getValueFromKey('USERID') as string

    this.getMultiTravererList()
  }

  handleEvent(event: string) {
    if (event.includes('multi-travel-management')) {
      this.Addnew = true;
    }
  }

  addNewMultiTraveler() {
    this.Addnew = true;
    this.resetFormAndState()//reset the form with default value
    this._CompanyManagementService.company_management_multiTravelerManagement('Add link','Add',this.commonObjPipes.GetAllMultiTravelerDetails.pipe.length)//GTM use
  }

  getMultiTravererList() {
    this.isLoading = true; // Start loading state

    this._camService.getMultiTraveler(this.sauserId, "0", 2).then((res) => {

      if (res.status == "Success") {
        // Bind all lists
        res.data.GetAllMultiTravelerDetails.forEach(($multi: any) => {
          $multi.AppliedOnName = res.data.GetRuleAppliesOn.filter(($app: any) => $app.ID == $multi.AppliedOn)[0].Name;
        })

        //get GetBranchData modify ID and Name parameter
        res.data.GetBranchData.forEach((rec: any) => {
          rec.ID = rec.SA_Branch_ID;
          rec.Name = rec.Branch_Name;
          delete rec.SA_Branch_ID;
          delete rec.Branch_Name;
        })

        this.bindLists('GetAllMultiTravelerDetails', res.data.GetAllMultiTravelerDetails);
        this.bindLists('GetRuleAppliesOn', res.data.GetRuleAppliesOn);
        this.bindLists('GetDesignationData', res.data.GetDesignationData);
        this.bindLists('GetdepartmentData', res.data.GetdepartmentData);
        this.bindLists('AssociateedWithBranchIni', res.data.AssociatedWithBranch);
        this.bindLists('GetProdectData', res.data.GetProdectData);
        this.bindLists('GetBranchData', res.data.GetBranchData);
        this.bindLists("GetGradeData", res.data.GetGradeData);
      } else {
      }
    }).catch((error) => {
      console.error("Error in getMultiTraveler API:", error);
    }).finally(() => {
      this.isLoading = false; // Stop loading after API response
    });
  }



  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }

  onRuleChange(selectedValue: any) {
    this.AssociatedWithBranchArray = [];
    this.branchIdArray = [];
    this.departmentArray = [];
    this.associatedRuleName = [];
    this.selectedAssoicatedRuleIdMap = {};
    this.selectedRule = selectedValue;
    this.deptDesGradeName = [];
    this.selectedAssoicatedDeptDesGradeIdMap = {};

    this.multiTravelerForm.patchValue({
      ruleAppliedFor: '',  // Clearing ruleAppliedFor field
      associatedWithBranchId: ''  // Clearing associatedWithBranchId field
    });

    if (this.selectedRule == 2) {
      this.multiTravelerForm.get('associatedWithBranchId')?.removeValidators(Validators.required);
    }

    if (this.selectedRule == 3) {
      this.query = 2;
      this.multiTravelerForm.get('associatedWithBranchId')?.setValidators(Validators.required);
    }

    if (this.selectedRule == 4) {
      this.query = 3;
      this.multiTravelerForm.get('associatedWithBranchId')?.setValidators(Validators.required);
    }

    if (this.selectedRule == 5) {
      this.query = 4;
      this.multiTravelerForm.get('associatedWithBranchId')?.setValidators(Validators.required);
    }

    // Clear all checked checkboxes when rule changes after an edit, except when editing and the rule is same.
    if (this.isEditing && this.editedItem && this.editedItem.AppliedOn != selectedValue.toString()) {
      this.branchIdArray = [];
      this.departmentArray = [];
      this.AssociatedWithBranchArray = [];
      // this.bindLists('GetDesignationData', []);
      // this.bindLists('GetdepartmentData', []);
      // this.bindLists('AssociateedWithBranchIni', []);
      // this.bindLists('GetProdectData', []);
      // this.bindLists('GetBranchData', []);
      // this.bindLists("GetGradeData", [])
      this.EditArrayLists.ruleAppliedFor = [];
      this.EditArrayLists.associatedWithBranchId = [];
    }

    this.filteredAssocatedWithRule = this.ruleAppliedFor.valueChanges.pipe(
      startWith(null),
      map((value: string | null) => {
        if (typeof value === 'string') {
          return this._filter(value);
        } else {
          return this.commonObjPipes[this.dropdowns[this.multiTravelerForm.value.ruleAppliedOn]]?.pipe.slice();
        }
      })
    );

  }

  getCheckboxLabel(): string {
    switch (this.multiTravelerForm.value.ruleAppliedOn) {
      case 2:
        return 'Branch(s)';
      case 3:
        return 'Department(s)';
      case 4:
        return 'Designation(s)';
      case 5:
        return 'Grade(s)';
      default:
        return '';
    }
  }


  onCheckboxChange(event: any, filterdAssocNames: any) {
    this.selectedAssoicatedRuleIdMap[filterdAssocNames.ID] = event.checked;
    if (event.checked) {
      if (!this.associatedRuleName.includes(filterdAssocNames.Name)) {
        this.associatedRuleName.push(filterdAssocNames.Name)
      }
      // Add the selected branchId to branchIdArray if it's not already present
      if (!this.branchIdArray.includes(filterdAssocNames.ID)) {
        this.branchIdArray.push(filterdAssocNames.ID);
      }
      this._camService.getMultiTraveler(this.sauserId, filterdAssocNames.ID, this.query).then((res) => {
        if (res.status === "Success") {
          this.bindLists('AssociatedWithBranch', res.data.AssociatedWithBranch);
          // Add refId to each object in res.data.AssociatedWithBranch
          const updatedBranchData = res.data.AssociatedWithBranch.map((item: any) => ({
            ...item,
            refId: [filterdAssocNames.ID]
          }));
          updatedBranchData.forEach(($branch: any) => {
            if (!this.AssociatedWithBranchArray.map(($a: any) => $a.ID).includes($branch.ID)) {
              this.AssociatedWithBranchArray.push($branch);
            } else {
              let currIndex: number = this.AssociatedWithBranchArray.findIndex(($asB: any) => $asB.ID == $branch.ID);
              if (currIndex >= -1) {
                this.AssociatedWithBranchArray[currIndex].refId.push(filterdAssocNames.ID);
              }
            }
          });
        }

        this.filteredDeptDesGrade = this.associatedWithBranchId.valueChanges.pipe(
          startWith(null),
          map((value: string | null) => {
            if (typeof value === 'string') {
              return this._filterDeptDesGrade(value);
            } else {
              return this.AssociatedWithBranchArray.slice();
            }
          })
        );

      });
    } else {
      this.associatedRuleName = this.associatedRuleName.filter(name => name.toLocaleLowerCase().trim() != filterdAssocNames.Name.toLocaleLowerCase().trim());
      // Remove the unchecked branchId from branchIdArray
      this.branchIdArray = this.branchIdArray.filter(id => id != filterdAssocNames.ID);
      this.AssociatedWithBranchArray = this.AssociatedWithBranchArray.map(item => {
        if (item.refId && item.refId.includes(filterdAssocNames.ID)) {
          item.refId = item.refId.filter((id: any) => id != filterdAssocNames.ID);
        }
        return item;
      }).filter(item => item.refId && item.refId.length > 0); // Remove items with empty refId
      const remainingNames = this.AssociatedWithBranchArray.map(item => item.name ?? item.Name);
      // // Step 3: Remove names from deptDesGradeName that are no longer in remainingNames
      this.deptDesGradeName = this.deptDesGradeName.filter(name => remainingNames.includes(name));
      this.departmentArray = this.AssociatedWithBranchArray.map(item => item.ID)
      this.filteredDeptDesGrade = this.associatedWithBranchId.valueChanges.pipe(
        startWith(null),
        map((value: string | null) => {
          if (typeof value === 'string') {
            return this._filterDeptDesGrade(value);
          } else {
            return this.AssociatedWithBranchArray.slice();
          }
        })
      );

    }


    const selectedAssociatedRuleId = Object.keys(this.selectedAssoicatedRuleIdMap)
      .filter(key => this.selectedAssoicatedRuleIdMap[parseInt(key)])


    this.multiTravelerForm?.get('ruleAppliedFor')?.setValue(selectedAssociatedRuleId.join(','));
    this.multiTravelerForm?.get('ruleAppliedFor')?.updateValueAndValidity();
    this.multiTravelerForm.patchValue({
      associatedWithBranchId: this.departmentArray.join(',')
    });
  }

  onDepartmentCheckbox(event: any, filteredName: any) {
    this.selectedAssoicatedDeptDesGradeIdMap[filteredName.ID] = event.checked;
    if (event.checked) {
      // Add the branchId to the departmentArray if it's not already present
      if (!this.deptDesGradeName.includes(filteredName.Name ?? filteredName.name)) {
        this.deptDesGradeName.push(filteredName.Name ?? filteredName.name)
      }
      // if (!this.departmentArray.includes(filteredName.ID)) {
      //   this.departmentArray.push(filteredName.ID);
      // }
    } else {
      // Remove the branchId from the departmentArray
      // this.departmentArray = this.departmentArray.filter(id => id != filteredName.ID);
      this.deptDesGradeName = this.deptDesGradeName.filter(
        name => name.toLocaleLowerCase().trim() !== (filteredName.name?.toLocaleLowerCase().trim() ?? filteredName.Name?.toLocaleLowerCase().trim())
      );
    }
    // Update the associatedWithBranchId form control with the updated departmentArray
    // this.multiTravelerForm.patchValue({
    //   associatedWithBranchId: this.departmentArray.join(',')
    // });
    const selectedDeptDesGrade = Object.keys(this.selectedAssoicatedDeptDesGradeIdMap).filter(key => this.selectedAssoicatedDeptDesGradeIdMap[parseInt(key)])
    this.multiTravelerForm?.get('associatedWithBranchId')?.setValue(selectedDeptDesGrade.join(','));
    this.multiTravelerForm?.get('associatedWithBranchId')?.updateValueAndValidity();
  }

  onSave() {

    this._CompanyManagementService.company_management_multiTravelerManagement('Save button','Save',this.commonObjPipes.GetAllMultiTravelerDetails.pipe.length)//GTM use

    if (this.multiTravelerForm.invalid) {
      return
    }
    const isUpdate = this.multiTravelerForm.value.multiTravelerRuleId != 0;
    this._camService.insertUpdateMultiTraveler(this.multiTravelerForm.value).then((res) => {
      if (res.status == "Success") {
        this.resetFormAndState()//reset the form with default value
        this.getMultiTravererList();
        this.Addnew = false;
        const message = isUpdate ? 'Multi traveler management has bee updated!' : 'Multi traveler management has bee saved successfully!';
        this._ToastrApiService.show('success', message);
        this._CommonService.formResetTrigger();
        this._CompanyManagementService.save_success('Multi travel management', 'Success')//GTM use

      }
    }).catch((error) => {
      console.error(error)
    })
  }

  onEdit(item: any) {
    this._CompanyManagementService.company_management_multiTravelerManagement('Edit button','Edit',this.commonObjPipes.GetAllMultiTravelerDetails.pipe.length)//GTM use
    this.Addnew = true;
    this.editedItem = item;
    this.isEditing = true;

    // First, reset the form and clear arrays
    this.multiTravelerForm.reset({
      multiTravelerRuleId: item.Rule_Id,
      numbarOfTraveler: item.TravellerCount,
      product: item.Product_Code,
      ruleAppliedOn: Number(item.AppliedOn),
      ruleAppliedFor: '',
      sauserid: this.sauserId,
      queryNo: 2,
      associatedWithBranchId: ''
    });

    // Clear existing arrays
    this.associatedRuleName = [];
    this.deptDesGradeName = [];
    this.selectedAssoicatedRuleIdMap = {};
    this.selectedAssoicatedDeptDesGradeIdMap = {};
    this.branchIdArray = [];
    this.departmentArray = [];
    this.AssociatedWithBranchArray = [];

    // Set the selected rule and query
    this.selectedRule = Number(item.AppliedOn);
    this.setQueryBasedOnRule(this.selectedRule);

    // Handle AppliedFor IDs
    const appliedForIds = item.AppliedFor?.split(",").filter((id: string) => id.trim() !== "") ?? [];
    const associatedWithBranchIds = item.AssociatedWithBranch_Id?.split(",").filter((id: string) => id.trim() !== "") ?? [];

    // For branches (ruleAppliedOn = 2), handle differently
    if (this.selectedRule === 2) {
      appliedForIds.forEach((id: string) => {
        const branch = this.commonObjPipes.GetBranchData.pipe.find((b: any) => b.ID.toString() === id);
        if (branch) {
          this.selectedAssoicatedRuleIdMap[branch.ID] = true;
          this.associatedRuleName.push(branch.Name);
          this.branchIdArray.push(branch.ID);
        }
      });

      this.multiTravelerForm.patchValue({
        ruleAppliedFor: appliedForIds.join(',')
      });
    } else {
      // For other rules (departments, designations, grades)
      appliedForIds.forEach((id: string) => {
        const item = this.commonObjPipes[this.dropdowns[this.selectedRule]].pipe.find((i: any) => i.ID.toString() === id);
        if (item) {
          this.selectedAssoicatedRuleIdMap[item.ID] = true;
          this.associatedRuleName.push(item.Name);
          this.branchIdArray.push(item.ID);

          // Load associated data for each selected item
          this.loadAssociatedData(item.ID);
        }
      });

      this.multiTravelerForm.patchValue({
        ruleAppliedFor: appliedForIds.join(',')
      });

      // After loading all associated data, set the associatedWithBranchId values
      setTimeout(() => {
        associatedWithBranchIds.forEach((id: string) => {
          const item = this.AssociatedWithBranchArray.find((i: any) => i.ID.toString() === id);
          if (item) {
            this.selectedAssoicatedDeptDesGradeIdMap[item.ID] = true;
            this.deptDesGradeName.push(item.Name || item.name);
            this.departmentArray.push(item.ID);
          }
        });

        this.multiTravelerForm.patchValue({
          associatedWithBranchId: associatedWithBranchIds.join(',')
        });
      }, 500);
    }
  }

  private setQueryBasedOnRule(rule: number): void {
    switch (rule) {
      case 3: this.query = 2; break;
      case 4: this.query = 3; break;
      case 5: this.query = 4; break;
      default: this.query = 1; break;
    }
  }

  private loadAssociatedData(id: string): void {
    this._camService.getMultiTraveler(this.sauserId, id, this.query).then((res) => {
      if (res.status === "Success") {
        const updatedBranchData = res.data.AssociatedWithBranch.map((item: any) => ({
          ...item,
          refId: [id]
        }));

        updatedBranchData.forEach(($branch: any) => {
          if (!this.AssociatedWithBranchArray.some(($a: any) => $a.ID === $branch.ID)) {
            this.AssociatedWithBranchArray.push($branch);
          } else {
            const currIndex = this.AssociatedWithBranchArray.findIndex(($asB: any) => $asB.ID === $branch.ID);
            if (currIndex >= 0) {
              this.AssociatedWithBranchArray[currIndex].refId.push(id);
            }
          }
        });

        this.filteredDeptDesGrade = this.associatedWithBranchId.valueChanges.pipe(
          startWith(null),
          map((value: string | null) => {
            if (typeof value === 'string') {
              return this._filterDeptDesGrade(value);
            } else {
              return this.AssociatedWithBranchArray.slice();
            }
          })
        );
      }
    });
  }

  onRemove(item: any) {
    this.currentItem = item;
    const dialogRef = this.dialog.open(this.selectionWarning, {
      data: item, // Pass the item data
    });
    this._CompanyManagementService.company_management_multiTravelerManagement('Remove button','Remove',this.commonObjPipes.GetAllMultiTravelerDetails.pipe.length)//GTM use
  }

  confirmDelete(item: any) {

    this._camService.deleteMultiTraveler(item.Rule_Id).then((res) => {
      if (res.status == "Success") {
        this.resetFormAndState()//reset the form with default value
        this.currentItem = undefined;
        this.getMultiTravererList()
        this._CompanyManagementService.multiTravelerManagement_Successfully('Confirm')//GTM use
      }
    })
  }

  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem);
      this._CompanyManagementService.multiTravelerManagement_remove('Proceed','Are you sure you want to remove this multi traveler management?');
    }

    if(!result){
      this._CompanyManagementService.multiTravelerManagement_remove('Cancel','Are you sure you want to remove this multi traveler management?');

    }
    this.dialog.closeAll(); // Closes the dialog
  }

  onCancel() {
    this.Addnew = false;
    this.resetFormAndState()//reset the form with default value
    this._CompanyManagementService.company_management_multiTravelerManagement('Cancel button','Cancel',this.commonObjPipes.GetAllMultiTravelerDetails.pipe.length)//GTM use

  }



  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockInvalidCharacters1(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '$', '|', '[', ']', '~', '--', '@', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }

  blockInvalidCharacters(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }
  // Block non-numeric input
  allowedNumberOnly(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  //chips method 
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      // this.associatedRuleName.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.ruleAppliedFor.setValue(null);
  }

  remove(assoName: string): void {

    const index = this.associatedRuleName.indexOf(assoName);
    if (index >= 0) {
      this.associatedRuleName.splice(index, 1);
      this.announcer.announce(`Removed ${assoName}`);
      const associatedRuleAppliedOn = this.commonObjPipes[this.dropdowns[this.multiTravelerForm.value.ruleAppliedOn]]?.pipe

      const associateRule = associatedRuleAppliedOn.find((rule: { Name: string; }) => rule.Name.toLocaleLowerCase().trim() == assoName.toLocaleLowerCase().trim());

      if (associateRule) {
        this.selectedAssoicatedRuleIdMap[associateRule.ID] = false;

        this.onCheckboxChange({ checked: false } as MatCheckboxChange, associateRule);

        const selectedAssoRule = Object.keys(this.selectedAssoicatedRuleIdMap).filter(key => this.selectedAssoicatedRuleIdMap[parseInt(key)]);
        this.multiTravelerForm.controls['ruleAppliedFor'].setValue(selectedAssoRule.join(','));
        this.multiTravelerForm.controls['ruleAppliedFor'].updateValueAndValidity();

      }

    }
  }

  removed(deptDesGraName: string): void {

    const index = this.deptDesGradeName.indexOf(deptDesGraName);
    if (index >= 0) {
      this.deptDesGradeName.splice(index, 1);

      const itemObj = this.AssociatedWithBranchArray.find((item: any) => (item.name ?? item.Name).trim().toLowerCase() == deptDesGraName.trim().toLowerCase())
      if (itemObj) {
        this.selectedAssoicatedDeptDesGradeIdMap[itemObj.ID] = false;

        const selectedItem = Object.keys(this.selectedAssoicatedDeptDesGradeIdMap).filter(key => this.selectedAssoicatedDeptDesGradeIdMap[parseInt(key)]);
        this.multiTravelerForm.controls['associatedWithBranchId'].setValue(selectedItem.join(","));
        this.multiTravelerForm.controls['associatedWithBranchId'].updateValueAndValidity();

      }
    }
  }


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.commonObjPipes[this.dropdowns[this.multiTravelerForm.value.ruleAppliedOn]]?.pipe.filter((branch: { Name: string }) => branch.Name.toLowerCase().includes(filterValue));
  }

  private _filterDeptDesGrade(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.AssociatedWithBranchArray.filter((branch: any) => (branch.name ?? branch.Name).toLowerCase().includes(filterValue));

  }


  private resetFormAndState(): void {
    // Reset form with default values
    this.multiTravelerForm.reset({
      multiTravelerRuleId: 0,
      numbarOfTraveler: '',
      product: '',
      ruleAppliedOn: '',
      ruleAppliedFor: '',
      sauserid: this.crypto.getValueFromKey('USERID') as string,
      queryNo: 1,
      associatedWithBranchId: ['']
    });

    // Clear all related arrays
    this.AssociatedWithBranchArray = [];
    this.branchIdArray = [];
    this.departmentArray = [];
    this.associatedRuleName = [];
    this.deptDesGradeName = [];

    // Clear selection maps
    this.selectedAssoicatedRuleIdMap = {};
    this.selectedAssoicatedDeptDesGradeIdMap = {};

    // Reset editing state
    this.isEditing = false;
    this.editedItem = null;
  }
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

}
